import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=402a142a"
import script from "./AddressView.vue?vue&type=script&lang=js"
export * from "./AddressView.vue?vue&type=script&lang=js"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=402a142a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports